export const DATADOG_RUM_PATHS = [
  '/under_approval',
  '/totur_complete_profile',
];

export const isDatadogRumPath = (pathname) =>
  typeof pathname === 'string' &&
  DATADOG_RUM_PATHS.some((p) => pathname.includes(p));
